import { render, staticRenderFns } from "./CloseButtom.vue?vue&type=template&id=03123644&"
import script from "./CloseButtom.vue?vue&type=script&lang=js&"
export * from "./CloseButtom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports